import { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { twJoin } from 'tailwind-merge'
import { useTranslation } from 'react-i18next'
import { CorrectionAction } from 'types'
import { faCircle } from '@fortawesome/pro-solid-svg-icons'

interface StatusProps {
  action: CorrectionAction | null
}

const Status: FC<StatusProps> = ({ action }) => {
  const { t } = useTranslation()

  return (
    <div
      className={twJoin(
        'inline-flex flex-row gap-2 items-center uppercase text-xs font-bold py-1 px-2 rounded-md border',
        action === CorrectionAction.Completed &&
          'bg-success-100 border-success-300 text-success-700',
        action === CorrectionAction.NotRequired &&
          'bg-primary-100 border-primary-300 text-primary-700',
        action === null && 'bg-neutral-100 border-neutral-300 text-neutral-700',
      )}
    >
      <FontAwesomeIcon icon={faCircle} size="2xs" />
      {action === null
        ? t('features.correctionsQueue.payrollActionStatuses.pending')
        : t(`features.correctionsQueue.payrollActionStatuses.${action}`)}
    </div>
  )
}

export default Status
